module.exports = __webpack_public_path__ + "img/1578254260.15d2e15f.jpg";